import axios from 'axios';
import { UserCycle } from '../../common/model/dto/user-cycle/user-cycle';
import { HormoneSummaryResponse } from '../../common/model/dto/hormone-summary';
import { Paginated } from '../../common/types';
import { ADMIN_USER_CYCLES_ROUTE } from '../../api/backend';

export const getUserCycles = async (userId: string, query: string) => {
  const { data } = await axios.get<Paginated<UserCycle>>(
    `${ADMIN_USER_CYCLES_ROUTE}/users/${userId}?${query}`
  );

  return data;
};

export const getUserCycleById = async (userCycleId: string) => {
  const { data } = await axios.get<UserCycle>(
    `${ADMIN_USER_CYCLES_ROUTE}/${userCycleId}`
  );

  return data;
};

export const getUserCycleHormoneSummary = async (
  userCycleId: string
): Promise<HormoneSummaryResponse> => {
  const { data } = await axios.get<HormoneSummaryResponse>(
    `${ADMIN_USER_CYCLES_ROUTE}/${userCycleId}/summary`
  );

  return data;
};
